import { Component, OnInit, Renderer2, ElementRef } from "@angular/core";
import { Platform } from "@ionic/angular";
import { Storage } from "@ionic/storage";
import { ToastController, LoadingController } from "@ionic/angular";
import { Router, ActivatedRoute } from "@angular/router";
import { Helper } from "../services/Helper";
import { APIService } from "../services/APIService";

declare let cordova: any;

@Component({
  selector: "app-video-call-screen",
  templateUrl: "./video-call-screen.page.html",
  styleUrls: ["./video-call-screen.page.scss"],
})
export class VideoCallScreenPage {
  ua: apiRTC.UserAgent = null;
  connectedSession: apiRTC.Session = null;
  currentCall: apiRTC.Call = null;
  localStream: apiRTC.Stream = null;
  remoteStream: apiRTC.Stream = null;

  onCall: boolean;

  opponentId: any;

  infoLabel: string;
  fcmToken: any;
  drName: any;
  loader: any;
  room: any;
  muted: any;

  constructor(
    private renderer: Renderer2,
    private elementRef: ElementRef,
    public platform: Platform,
    private helper: Helper,
    private storage: Storage,
    private loadingController: LoadingController,
    public toastController: ToastController,
    private router: Router,
    private apiservice: APIService,
    private route: ActivatedRoute
  ) {
    this.platform.backButton.subscribeWithPriority(1, () => {
      this.dismissLoading();
      this.clearStreams();
      this.currentCall.hangUp();
      this.currentCall = null;
      this.onCall = false;
      this.router.navigate(["tabs/tab1"]);
    });

    this.opponentId = this.route.snapshot.params["price"];
    console.log("opponentId", this.opponentId);

    this.storage.get("fcmToken").then((fcmToken) => {
      this.storage.get("firstname").then((firstname) => {
        this.fcmToken = fcmToken;
        this.drName = firstname;
      });
    });

    this.onCall = false;
    this.muted = false;
    this.infoLabel = "Initializing...";

    this.platform.ready().then(() => {
      if (this.platform.is("ios")) {
        cordova.plugins.iosrtc.registerGlobals();
      }
      const script = this.renderer.createElement("script");
      script.src = "https://cloud.apizee.com/apiRTC/apiRTC-latest.min.js";
      script.onload = () => {
        console.log("apiRTC loaded");
        this.startApp();
      };
      this.renderer.appendChild(this.elementRef.nativeElement, script);
    });
  }

  startApp() {
    // this.presentLoading().then(() => {

    // this.preview();
    console.log("startApp");

    apiRTC.setLogLevel(10);

    this.ua = new apiRTC.UserAgent({
      uri: "apzkey:7fc622187adcf8f98bdc3c321777f7eb",
    });

    let registerInformation = {
      cloudUrl: "https://cloud.apizee.com",
    };

    this.ua
      .register(registerInformation)
      .then((session) => {
        console.log("User registered with session: ", session);

        session
          .on("contactListUpdate", (updatedContacts) => {
            console.log("contactListUpdate", updatedContacts);
          })
          .on("incomingCall", (invitation) => {
            invitation.accept().then((call) => {
              this.currentCall = call;
              this.setCallListeners();
              this.onCall = true;
            });
          });
        this.connectedSession = session;
        this.infoLabel = "Your id: " + session.getId();
        this.onClickCall();
      })
      // })
      .catch(function (error) {
        this.dismissLoading();
        console.error("User agent registration failed", error);
      });

    this.checkPermissions();
  }

  setCallListeners = () => {
    this.currentCall
      .on("streamAdded", (stream) => {
        this.dismissLoading();
        console.log("streamAdded :", stream);
        this.remoteStream = stream;
        stream.addInDiv(
          "remote-stream",
          "remote-media",
          { width: "auto", height: "100%" },
          false
        );
      })
      .on("localStreamAvailable", (stream) => {
        console.log("localStreamAvailable", stream);
        this.localStream = stream;
        stream.addInDiv(
          "local-stream",
          "local-media",
          { width: "auto", height: "200px" },
          false
        );
      })

      .on("streamRemoved", (stream) => {
        stream.removeFromDiv("remote-stream", "remote-media");
        this.remoteStream = null;
      })
      .on("userMediaError", (e) => {
        console.error("userMediaError detected : ", e);
        console.error("userMediaError detected with error : ", e.error);
      })
      .on("hangup", () => {
        this.clearStreams();
        this.currentCall = null;
        this.onCall = false;
      });
  };

  onClickCall = () => {
    if (!this.opponentId) {
      console.warn("Opponent number is null");
      return;
    }
    if (this.onCall) {
      console.warn("Call is already started");
      return;
    }
    let contact = this.connectedSession.getOrCreateContact(this.opponentId);
    let call = contact.call();
    if (!call) {
      console.warn("Cannot establish the call");
      return;
    }
    this.currentCall = call;
    this.setCallListeners();
    this.onCall = true;
  };

  onClickHangUp = () => {
    this.clearStreams();
    if (this.currentCall) {
      this.currentCall.hangUp();
      this.currentCall = null;
    }
    this.onCall = false;
    this.router.navigate(["tabs/tab1"]);
  };

  checkPermissions = () => {
    cordova.plugins.diagnostic.requestRuntimePermissions(
      (statuses) => {
        console.log("Permissions statuses: ", statuses);
      },
      (error) => {
        console.error("The following error occurred: ", error);
      },
      [
        cordova.plugins.diagnostic.permission.CAMERA,
        cordova.plugins.diagnostic.permission.RECORD_AUDIO,
      ]
    );
  };

  clearStreams = () => {
    if (this.localStream) {
      this.localStream.removeFromDiv("local-stream", "local-media");
    }
    if (this.remoteStream) {
      this.localStream.removeFromDiv("local-stream", "local-media");
    }
    this.localStream = null;
    this.remoteStream = null;
  };

  mute() {
    console.log("mute called");
    this.localStream.muteAudio();
    this.muted = true;
  }

  unmute() {
    console.log("unmute called");
    this.localStream.unmuteAudio();
    this.muted = false;
  }

  async presentLoading() {
    this.loader = await this.loadingController.create({
      translucent: true,
    });
    await this.loader.present();
  }

  async dismissLoading() {
    await this.loader.dismiss();
  }
}
